import { makeStyles } from "@material-ui/core";

export const commitGoalStyles = makeStyles((theme) => ({
  tipTitle: {
    color: "#00A3A3",
    fontFamily: "Lato",
    fontWeight: 700,
    fontSize: theme.typography.pxToRem(16),
  },
  question: {
    fontFamily: "Inter",
    color: "#000000",
    fontWeight: 500,
    fontSize: theme.typography.pxToRem(24),
    margin: "25px 0px 25px 0px",
  },
  answerContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "20px",
  },
  answer: {
    fontFamily: "Lato",
    color: "#000000",
    fontWeight: 400,
    fontSize: theme.typography.pxToRem(16),
    background: "#FFFFFF",
    border: "1px solid #A7BBD4",
    borderRadius: "8px",
    width: "170px",
    height: "72px",
    "&:hover": {
      boxShadow: "inset 0px -4px 0px #A7BBD4",
    },
  },
  answerSelected: {
    backgroundColor: "#ECF3F8",
  },
  tipDetails: {
    marginBottom: "30px",
  },
}));
